import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaTimeRangePicker } from "ecCom";

@observer
export default class TimeRangePickerItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaTimeRangePicker
        ecId={`${this.props.ecId}_WeaTimeRangePicker@xlqysl`}
        {...bindObj.bind()}
        value={toJS(bindObj.value)}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/TimeRangePickerItem.js